import { render, staticRenderFns } from "./proSortClass.vue?vue&type=template&id=3440ba0e&"
import script from "./proSortClass.vue?vue&type=script&lang=js&"
export * from "./proSortClass.vue?vue&type=script&lang=js&"
import style0 from "./proSortClass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports